import { Icon } from "@chakra-ui/react";
import { FaGift } from "react-icons/fa";

export function FidelityProgramGiftSuccessIcon() {
  return <Icon as={FaGift} color="white" mt="5px" />;
}
